import { createContext } from 'react'

const RouterContext = createContext(null)

/**
 * A custom context instance for our router type
 */
export default RouterContext
